export const imperialUnitsCountryCodes = ['en-US', 'es-US', 'USA'];

export const milesMultiplicator = 0.621371;
